export default __webpack_public_path__ + "media/convinience_banner_en.122abfee.png";